module.exports = __webpack_public_path__ + "img/notifications.eaa8e9ae.svg";